export const STEPS = {
  CATEGORIES: 'choose_category',
  SUBCATEGORIES: 'choose_subcategory',
  TEXTS: 'choose_template',
  BACKGROUNDS: 'choose_background',
  REVIEWS: 'choose_review',
}

export const STEPS_ORDER = [
  STEPS.CATEGORIES,
  STEPS.SUBCATEGORIES,
  STEPS.TEXTS,
  STEPS.BACKGROUNDS,
]

export const SCENARIO_TYPES = {
  PORTFOLIO: 'portfolio',
  REVIEWS: 'reviews',
  BOOK_SMALL: 'book_small',
  BACK_TO_BUSINESS: 'back_to_business',
  BUSINESS_INFO: 'business_info',
  BOOKSY_AWARDS: 'booksy_awards',
}

export const DF_SCREEN_NAMES = {
  SHARE_POST_STARTED: 'share_post_started',
  SHARE_POST_HASHTAG: 'share_post_hashtag',
  SHARE_POST_CHANNEL: 'share_post_channel',
  SHARE_POST_FINISHED: 'share_post_finished',
  SHARE_PHOTO: 'share_photo',
  SHARE_PORTFOLIO_PHOTO: 'share_portfolio_photo',
  SHARE_SAFETY_RULES: 'share_safety_rules',
  SHARE_REVIEW: 'share_review',
  SHARE_REVIEW_PHOTO: 'share_review_photo',
  SHARE_YOUR_PROFILE: 'share_your_profile',
}

export const WAYS_OF_ADDING_DF = {
  MARKETING: 'marketing_tab',
  NOTIFICATION: 'notification',
  COVER_PHOTO: 'cover_photo',
  PROFILE_TAB: 'profile_tab',
  PROFILE: 'profile',
  PHOTO: 'photo',
  SAFETY_RULES: 'safety_rules',
  REVIEWS: 'reviews',
  REVIEW_PHOTO: 'review_photo',
  SERVICE_PHOTO: 'service_photo',
  VENUE_PHOTO: 'venue_photo',
  PUSH: 'push',
  DEEPLINK: 'deeplink',
  FLASH_SALE: 'flash_sale',
  LAST_MINUTE: 'last_minute',
  HAPPY_HOURS: 'happy_hours',
  LOYALTY_PROGRAM_MAIN: 'loyalty_program_main',
  BOOKSY_PAY_ONBOARDING: 'booksy_pay_onboarding',
  VALENTINES_DAY: 'valentines_day',
}

export const SHARE_NETWORKS = {
  FACEBOOK: 'facebook',
  WHATSAPP: 'whatsapp',
}

export const BACKGROUND_CHOICES = {
  OWN: 'own',
  BOOKSY_TEMPLATE: 'booksy',
} as const
